<template>
  <button :class="[color, { invalid: isInvalid }]">
    <slot />
  </button>
</template>

<script>

export default {
  name: 'Button',

  props: {
    color: {
      type: String,
      default: 'blue',
      validator: value => ['blue', 'gold'].includes(value)
    },

    isInvalid: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
button {
  width: 80%;
  max-width: 335px;
  height: 40px;
  font-size: 15px;
  line-height: 22.5px;
  font-weight: 700;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1.12px;
  color: white;
  background-color: rgb(14, 53, 127);
  border: none;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  -webkit-transition-property: color, background, border, opacity;
  -o-transition-property: color, background, border, opacity;
  transition-property: color, background, border, opacity;
}

button.gold {
  background-color: #FFAE00;
}

button.invalid {
  background-color: #c2c2c2;
  opacity: 0.65;
}

button:hover {
  background-color: rgb(14, 53, 127);
}
</style>
